import getCollection from './getCollection'
import getDataById from 'actions/base/getDataById'

const getCustomer = async (id) => getDataById(id, getCollection)

export default getCustomer
